import React from 'react';
import {connect} from 'react-redux'
import {reduxForm} from 'redux-form/immutable';
import Disease from "./HealthQuestionnaireForm/Disease";
import Disability from "./HealthQuestionnaireForm/Disability";
import { Alert, Button } from 'antd'
import {fromJS} from 'immutable'

const formFieldsetStyle = {
    border: 0,
    margin: 0,
    padding: 0,
    minWidth: 0,
};

let HealthQuestionnaireForm = props => {
    const { handleSubmit, isLocked } = props;
    return (
        <form onSubmit={isLocked ? undefined : handleSubmit} noValidate>
            {isLocked && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: '16px' }}
                    message="此表單已由註冊組鎖定，請聯繫註冊組開啟後再修改。"
                />
            )}
            <fieldset disabled={isLocked} style={formFieldsetStyle}>
                <Disease/>
                <Disability/>
            </fieldset>
            <Button htmlType="submit" type={'primary'} size={'large'} disabled={isLocked} style={{width: '100%', marginTop: '10px'}}>
                {isLocked ? '已鎖定' : '送出'}
            </Button>
            <br/>
            <br/>
            <br/>
        </form>
    )
}

HealthQuestionnaireForm = reduxForm({
    form: 'editHealthQuestionnaire', // a unique identifier for this form
    enableReinitialize: true,
})(HealthQuestionnaireForm)

HealthQuestionnaireForm = connect(
    state => {
        const data = state.getIn(['HealthQuestionnaire', 'data']);
        const safeData = data && data.toJS ? data.toJS() : (data || {});
        return {
            initialValues: fromJS(safeData),
            isLocked: !!safeData.ques_check,
        };
    },
)(HealthQuestionnaireForm)
export default HealthQuestionnaireForm



// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/HealthQuestionnaireContaioner/HealthQuestionnaireForm.jsx